module.exports = __webpack_public_path__ + "img/bg9@2x.fca68e41.jpg";